module.exports = __webpack_public_path__ + "static/img/icon-PAR.aec01eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-PAR.svg
// module id = slAP
// module chunks = 0